import { render, staticRenderFns } from "./organizationDetail.vue?vue&type=template&id=1e9da310&scoped=true&"
import script from "./organizationDetail.vue?vue&type=script&lang=js&"
export * from "./organizationDetail.vue?vue&type=script&lang=js&"
import style0 from "./organizationDetail.vue?vue&type=style&index=0&id=1e9da310&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9da310",
  null
  
)

export default component.exports